module.exports = __webpack_public_path__ + "static/media/curRedaccion.9c7c5acc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/curRedaccion.png
// module id = 798
// module chunks = 0